import AppDataService from "./AppDataService";

const COMMON_BASE = 'Dashboard'

export default class DashboardDataService {
    static async getListDetails(){
        return await AppDataService.get(`${COMMON_BASE}/GetListDetails`);
    }

    static async getSubmissionList(data){
        return await AppDataService.post(`${COMMON_BASE}/SubmissionList`, data);
    }

    static async CheckIfDataPresent(){
        return await AppDataService.get(`${COMMON_BASE}/CheckIfDataPresent`);
    }

    static async downloadDashboardExcelData() {
        return await AppDataService.get(`${COMMON_BASE}/ExcelDashboardData`)
    }

    static async getAccountStatus(cancelToken) {
        return await AppDataService.get(`${COMMON_BASE}/GetAccountStatus`,  cancelToken ? {cancelToken: cancelToken.token} : {})
    }
}